<style scoped lang="less" src="./../assets/AdTip.less"></style>
<template>
  <div class="adtip" v-if="show && !isExpert && showAd">
    <span class="close" @click="close" data-track="djk_kj_download_close"></span>
    <div class="right" @click="download">
      <div data-track="djk_kj_download_go" class="go">
        <h2>宝宝树孕育</h2>
        <p>{{msg}}</p>
      </div>
      <span class="download">立即下载</span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'AdTip',
    data() {
      return {
        show: true,
        isExpert: this.$route.name === 'ExpertLiveInfo'
      };
    },
    computed: {
      showAd() {
        return this.$route.query.channel_from === 'zibizheng';
      },
      msg() {
        return this.showAd ? '90%的妈妈正在使用' : '下载APP 享受更好的听课体验';
      },
      down() {
        return this.showAd ? 'http://r.babytree.com/huDqwSn' : 'https://m.babytree.com/community/intro.php?refcode=app_dajingkang_170410';
      }
    },
    methods: {
      close() {
        this.show = false;
      },
      download() {
        // 保证日志发送出去
        setTimeout(() => {
          location.href = this.down;
        }, 200);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// AdTip.vue?c51afd2e